export default {
  quotas: null,
};
